import React, { useContext } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { AuthContext } from './Auth'
import { CSpinner } from '@coreui/react'

const PrivateRoute = ({ component: RouteComponent, ...rest }) => {
  const { currentUser, isLoading } = useContext(AuthContext)
  //console.log(currentUser)
  return currentUser ? <Outlet /> : !isLoading ? <Navigate to="/login" /> : <Loader />
}

const Loader = () => {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ width: '100%', marginTop: 60 }}
    >
      <CSpinner color="black" />
    </div>
  )
}

export default PrivateRoute
